
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import { obtenerDevolucionesHistorialPaginaAction, obtenerDevolucionesHistorialRegistrosAction } from "./../../../ducks/devolucionesHistorial"
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import ButtonDowloadEstadoCueta from "./ButtonDowloadEstadoCueta"
import ButtonVoucherDevolucion from "./ButtonVoucherDevolucion"
import DialogMensaje from "./DialogMensaje"
import FiltroEstatusDevolucion from "./FiltroEstatusDevolucion"
const columns = [
    { id: "1", minWidth: 50, align: "center", label: "Referencia" },
    { id: "2", minWidth: 50, align: "center", label: "Nombre" },
    { id: "3", minWidth: 50, align: "center", label: "Motivo" },
    { id: "4", minWidth: 50, align: "center", label: "Estatus" },
    { id: "5", minWidth: 50, align: "center", label: "Banco" },
    { id: "6", minWidth: 50, align: "center", label: "CLABE" },
    { id: "7", minWidth: 50, align: "center", label: "RFC" },
    { id: "8", minWidth: 50, align: "center", label: "Documento" },
    { id: "9", minWidth: 50, align: "center", label: "Comentario" },
    { id: "10", minWidth: 50, align: "center", label: "Comprobante" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TDevolucion = () => {
    const { listDevolucionesHistoria, total, pagina, registros } = useSelector(store => store.devolucionesHistorial)
    const rows = listDevolucionesHistoria ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesHistorialPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesHistorialRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <Grid container>
                    <Grid item xs={3}>
                        <FiltroEstatusDevolucion />
                    </Grid>
                </Grid>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.IdDevolucionSolicitud}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row?.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.Nombre} ${row?.Apellidos}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.CatDevolucion?.Descripcion}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.CatEstatusDevolucion?.Descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.Banco?.Nombre}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.CuentaClave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.RFC}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <ButtonDowloadEstadoCueta
                                                IdDevolucionSolicitud={row?.IdDevolucionSolicitud}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <DialogMensaje Mensaje={row?.Motivo} />
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (row?.CatEstatusDevolucion?.IdCatEstatusDevolucion === 3) &&
                                                <ButtonVoucherDevolucion
                                                    Devolucion={row}
                                                />
                                            }

                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registros}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TDevolucion